/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Scope_Always_ColleagueInputs */



/**
* | output |
* | --- |
* | "All conversations with this colleague" |
*
* @param {Meeting_Scope_Always_ColleagueInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_scope_always_colleague = /** @type {((inputs?: Meeting_Scope_Always_ColleagueInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Scope_Always_ColleagueInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Alle gesprekken met deze collega")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les conversations avec ce collègue")
	return /** @type {LocalizedString} */ ("All conversations with this colleague")
});